import { Box, Flex, Image } from '@mantine/core'

import classes from '@/modules/accounts/components/AccountItem/AccountItem.module.css'
import type { AdvisorAccountItemProps } from '@/modules/advisors/users/pages/[id]/components/AdvisorAccountItem/AdvisorAccountItem.types'

import { Text } from '@/components/Text/Text'
import { Tooltip } from '@/components/Tooltip/Tooltip'

import { formatMoney } from '@/helpers/formatMoney.helper'
import { getCurrentBalanceType } from '@/helpers/getCurrentBalanceType.helper'

export function AdvisorAccountItem({ account }: AdvisorAccountItemProps) {
  const currentBalance = getCurrentBalanceType(account.type, account.subtype)

  return (
    <Box className={classes.account}>
      <Tooltip
        label={`${account.name}${account.institution?.name ? ` · ${account.institution.name}` : ''}`}
        withIcon={false}
      >
        <Text truncate="end" variant="body_3">
          {account.name}
        </Text>
      </Tooltip>

      {account.mask && (
        <Text mt={22} variant="body_2_black">
          **** **** **** {account.mask}
        </Text>
      )}

      <Flex align="center" justify="space-between" mt={19}>
        {account.balance.isBalanceReady && (
          <Text variant="body_1_semibold">
            {formatMoney(
              account.balance[currentBalance],
              account.balance.currency,
            )}
          </Text>
        )}

        {!account.balance.isBalanceReady && (
          <Text variant="body_2">Balance available soon</Text>
        )}

        {account.logo && <Image alt={account.name} src={account.logo} w={32} />}
      </Flex>
    </Box>
  )
}
